<template>
  <responsive-model v-model="model" :btn-props="{ loading, disabled: loading }" :btn-text="$t('estimated.keep')"
                    closeable :title="$t('estimated.choose_city')" @close="resetForm" @open="onOpen" @submit="onSubmit">
    <van-radio-group v-model="city_id" class="flex flex-col gap-4 mb-3">
      <van-radio v-for="(item, index) in cities" :key="index" :name="item.id" @click="update(item.id)">{{ item.name }}
      </van-radio>
    </van-radio-group>
  </responsive-model>
</template>

<script setup>
import {getCities} from "~/plugins/API/review";
import ResponsiveModel from "~/components/common/dialogs/responsive.vue";

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  cityId: {
    Type: String,
    default: ''
  }
});
const model = computed({
  get() {
    return props.modelValue
  },
  set(val) {
    emit('update:modelValue', val)
  }
})
const cities = ref([]);
const city_id = ref('');
const emit = defineEmits(['update:modelValue', 'update:cityId', 'onSubmit'])
const {isLoading: loading, mutateAsync} = getCities();
const getCityList = () => {
  mutateAsync().then(({data}) => {
    cities.value = data.cities
  })
}
const onSubmit = () => {
  emit('onSubmit')
  emit('update:modelValue', false)
}
const onOpen = () => {
  getCityList()
}
const update = (id) => {
  city_id.value = id
  emit('update:cityId', id)
}
const resetForm = () => {
  emit('update:modelValue', false)
}
</script>

<style lang="scss" scoped>

</style>